module.exports = __webpack_public_path__ + "9f11caeb3b91de94cb33bb370ffe002e.png";